import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './TOTDPage.css'
import ReactMarkdown from 'react-markdown';

const TOTDPage: React.FC = () => {

  const location = useLocation();
  const navigate = useNavigate();

  const post = location.state?.post;

  if (!post) {
    // If no post is found in the state, redirect to the ThoughtOfTheDay page
    return (
      <div className="totd-page">
        <p>Sorry, no post data found. Please go back and select a post.</p>
        <button onClick={() => navigate(-1)}>Go Back</button>
      </div>
    );
  }

  const date = new Date(post.date).toLocaleDateString();

  return (
      <div className="totd-page">
      <h1>{post.title}</h1>
      <p className="post-date">{date}</p>
      <div className="post-content">
        <ReactMarkdown>{post.content}</ReactMarkdown>
      </div>
    </div>
  );
};

export default TOTDPage;
